/* eslint-disable no-undef */
// eslint-disable-next-line react/prop-types

import React, { useState } from 'react';

import { ADGMSnackbar, CancelApplicationModal, ADGMImage } from 'aurora-components';
// import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Hidden from '@material-ui/core/Hidden';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { Alert } from '@material-ui/lab';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import { taskHandler, keyEmptyCheck } from 'aurora-utils/utils';
import isObject from 'lodash/isObject';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import error, { errorProps } from 'aurora-utils/error';
import messages from 'aurora-translations';

import { withStyles } from '@material-ui/core/styles';
import AutoCancellationBar from 'aurora-section-components/AutoCancellationBar';
import { STATUS_COLOR_BY_APPLICATION_STATUS, propertiesKeysMap } from './constants';
import styles from './styleJss';
import PropertyBadge from '../ADGMPropertiesV2/PropertyList/Badge';

export const ApplicationStatus = withStyles(styles)(({ customApplicationStatus, application, classes }) => {
  const { progressStatus } = application?.applicationDetails ?? {};
  return (
    <Typography className={classes.taskStatusText} variant='body1'>
      <svg width='8' height='8' viewBox='0 0 8 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <circle cx='4' cy='4' r='4' fill={STATUS_COLOR_BY_APPLICATION_STATUS[progressStatus] ?? ''} />
      </svg>
      {customApplicationStatus || keyEmptyCheck(progressStatus)}
    </Typography>
  );
});

function HeaderV2(props) {
  const {
    classes,
    failure,
    commonError,
    application,
    downloadCertificatesList,
    handleSubmitCancelApplication,
    downloadReceipt,
    applicationId,
    property,
    showPropertyHeader,
    task,
    isPaymentApproved,
    appointmentData,
    customApplicationStatus,
  } = props;

  const locale = localStorage.getItem('lang');

  const cancelHandler = () => {
    handleSubmitCancelApplication(applicationId);
  };

  const [isModalOpenApplicationReject, setModalOpenApplicationReject] = useState(false);
  const [isDownloadMenuOpen, setDownloadMenuOpen] = useState(null);
  const handleClose = () => {
    setDownloadMenuOpen(null);
  };
  const toggleModalApplicationReject = () => {
    setModalOpenApplicationReject(!isModalOpenApplicationReject);
  };

  const SHOW_CANCEL_APPLICATION_BUTTON =
    application?.applicationDetails?.initiator === true &&
    application?.applicationDetails?.canCancel === true &&
    typeof handleSubmitCancelApplication === 'function';

  const UNIT = property?.propertyType === 4;
  const PLOT = property?.propertyType === 1;
  const ImageSrc = PLOT ? 'land_property.svg' : 'PropertyDetails-Unit.svg';
  const { community, district, plotNumber, unitNumber, buildingNumber } = propertiesKeysMap[locale];
  return (
    <>
      {failure?.statusCode && (
        <Alert severity='error' className={classes.errorMessage}>
          {keyEmptyCheck(failure?.message)}
        </Alert>
      )}
      <Grid container spacing={2} className={classes.initiateserviceSect}>
        <Grid item xs={12} md={8} lg={9}>
          {showPropertyHeader ? (
            <Grid item className={classes.headerContainer}>
              <Grid item xs={12} md={9} className={classes.propertyDetailsContainer}>
                <Grid item className={classes.imgCls}>
                  <ADGMImage name={ImageSrc} alt={ImageSrc} className={classes.headerImage} />
                </Grid>
                <Grid item>
                  <Typography variant='h6' className={classes.title}>
                    {UNIT ? (
                      <span>
                        {keyEmptyCheck('Unit')} {property?.[unitNumber]}, {keyEmptyCheck('building')}{' '}
                        {property?.[buildingNumber]}{' '}
                      </span>
                    ) : (
                      <span>
                        {keyEmptyCheck('Plot')} {property?.[plotNumber]}
                      </span>
                    )}
                    <div className={classes.chip}>{keyEmptyCheck(PLOT ? 'Plot' : 'Unit')}</div>
                  </Typography>

                  <Typography variant='h6' className={classes.subInfo}>
                    {property?.[community]}, {property?.[district]}
                  </Typography>
                  <div className={classes.statusesWrapper}>
                    <Typography variant='h6' className={classes.badgeContainer}>
                      <PropertyBadge
                        locale={locale}
                        property={property}
                        isOwnership={false}
                        isLease
                        expanded={false}
                        handleExpand={() => {}}
                      />
                    </Typography>
                    <Hidden smUp>
                      <div className={classes.mainBtnholdaer}>
                        <ApplicationStatus status={application?.applicationDetails?.progressStatus} classes={classes} />
                      </div>
                    </Hidden>
                  </div>
                </Grid>
              </Grid>
              <Hidden smDown>
                <Grid item xs={12} md={3}>
                  <div className={classes.mainBtnholdaer}>
                    <ApplicationStatus
                      status={application?.applicationDetails?.progressStatus}
                      classes={classes}
                      customApplicationStatus={customApplicationStatus}
                    />
                  </div>
                </Grid>
              </Hidden>
            </Grid>
          ) : (
            <Grid container className={classes.itemsCenter}>
              <Grid item xs={12} md={9}>
                <div className={classes.textHolder}>
                  <Typography variant='h5' component='h1' className={classes.Title}>
                    {keyEmptyCheck(application?.applicationDetails?.applicationType || application?.applicationType)}
                  </Typography>
                  <Typography variant='body1' className={classes.headsubtitle}>
                    {keyEmptyCheck('Application_ID')} :{' '}
                    {application?.applicationDetails?.applicationNumber || application?.applicationNumber}
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={12} md={3}>
                <div className={classes.mainBtnholdaer}>
                  <ApplicationStatus
                    application={application}
                    classes={classes}
                    customApplicationStatus={customApplicationStatus}
                  />
                </div>
              </Grid>
            </Grid>
          )}
          {isPaymentApproved && (
            <Box mt={3} className={classes.approvedToPaymentBar}>
              <ADGMImage name='approve.svg' alt='approve-icon' />
              {keyEmptyCheck('application_approved_proceed_to_payment')}
            </Box>
          )}
          {appointmentData?.visitDate && appointmentData?.startTime && (
            <Box mt={3} className={classes.appointmentBar}>
              <ADGMImage name='appointmentClock.svg' alt='clock-icon' />
              <Box>
                <Box>
                  {keyEmptyCheck(
                    appointmentData?.appointmentType === 'VIRTUAL'
                      ? 'virtual_appointment_scheduled_for_signature_date_time'
                      : 'appointment_scheduled_for_signature_date_time',
                    {
                      date: appointmentData?.visitDate,
                      time: appointmentData?.startTime,
                    },
                  )}
                </Box>
                {appointmentData?.appointmentType === 'PHYSICAL' && (
                  <Box>
                    {keyEmptyCheck('Address')}{' '}
                    {locale === 'en' ? appointmentData?.locationNameEn : appointmentData?.locationNameAr}{' '}
                  </Box>
                )}
              </Box>
            </Box>
          )}
        </Grid>
        <Grid item xs={12} md={4} lg={3}>
          <div className={classes.btnHolder}>
            {(downloadCertificatesList?.length || typeof downloadReceipt === 'function') && (
              <>
                <Button
                  className={classes.dropDownDownloadBtn}
                  aria-controls='download-menu'
                  aria-haspopup='true'
                  onClick={e => setDownloadMenuOpen(e.currentTarget)}
                >
                  <span>{keyEmptyCheck('download')}</span>
                  <ADGMImage
                    name={isDownloadMenuOpen ? 'arrow-up-white.svg' : 'arrow-down-white.svg'}
                    alt='arrow down'
                  />
                </Button>
                <Menu
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                  id='download-menu'
                  anchorEl={isDownloadMenuOpen}
                  open={Boolean(isDownloadMenuOpen)}
                  onClose={() => setDownloadMenuOpen(null)}
                  getContentAnchorEl={null}
                  classes={{
                    paper: classes.navMenuDropdown,
                    list: classes.menuList,
                  }}
                  PaperProps={{
                    style: {
                      borderRadius: '0px',
                    },
                  }}
                >
                  {[...(downloadCertificatesList || [])].map(doc => (
                    <MenuItem
                      key={doc.title}
                      onClick={() => {
                        doc?.downloadHandler();
                        handleClose();
                      }}
                    >
                      <ADGMImage name='Download-Icon.svg' alt='Icon' />
                      {keyEmptyCheck(doc.title)}
                    </MenuItem>
                  ))}
                </Menu>
              </>
            )}

            {task && task?.type !== 'NOTIFICATION' && (
              <Grid item xs={12} className={classes.btnWrapper}>
                <Button
                  variant='contained'
                  color='primary'
                  className={[classes.primary, classes.downloadBtnoutline, classes.btnV2Styles]}
                  onClick={() => taskHandler(task)}
                >
                  {keyEmptyCheck(task?.type === 'REG_PAYMENT' ? 'proceed_to_payment' : 'Proceed_with_application')}
                </Button>
              </Grid>
            )}

            {/* {SHOW_CANCEL_APPLICATION_BUTTON && (
              <Button
                variant='outlined'
                color='primary'
                className={classes.downloadBtnoutline}
                onClick={toggleModalApplicationReject}
              >
                <CancelOutlinedIcon /> <FormattedMessage {...messages.cancel_application} />
              </Button>
            )} */}
            {SHOW_CANCEL_APPLICATION_BUTTON && (
              <Button
                variant='outlined'
                color='primary'
                className={classes.cancelBtn}
                onClick={toggleModalApplicationReject}
              >
                <FormattedMessage {...messages.cancel_application} />
              </Button>
            )}
          </div>
        </Grid>

        {application?.applicationDetails?.autoCancellationReason && (
          <Grid item xs={12}>
            <AutoCancellationBar />
          </Grid>
        )}

        <CancelApplicationModal
          open={isModalOpenApplicationReject}
          onClose={toggleModalApplicationReject}
          toggleModal={toggleModalApplicationReject}
          cancelApplication={cancelHandler}
        />
      </Grid>

      {isObject(commonError) && (
        <ADGMSnackbar
          message={
            isObject(keyEmptyCheck(commonError?.message)) ? keyEmptyCheck(commonError?.message) : commonError?.message
          }
        />
      )}
    </>
  );
}

HeaderV2.propTypes = {
  classes: PropTypes.object.isRequired,
  locale: PropTypes.string,
  handleSubmitCancelApplication: PropTypes.func.isRequired,
  application: PropTypes.object.isRequired,
  failure: errorProps,
  commonError: errorProps,
  downloadCertificatesList: PropTypes.array,
  downloadReceipt: PropTypes.func.isOptional,
  applicationId: PropTypes.string.isRequired,
  showPropertyHeader: PropTypes.boolean,
  isPaymentApproved: PropTypes.boolean,
  appointmentData: PropTypes.boolean,
  property: PropTypes.object,
  task: PropTypes.object,
  customApplicationStatus: PropTypes.node,
};
HeaderV2.defaultProps = {
  failure: error,
  commonError: null,
  locale: 'en',
  downloadCertificatesList: [],
  downloadReceipt: null,
  showPropertyHeader: false,
  isPaymentApproved: false,
  appointmentData: false,
  property: {},
  task: null,
  customApplicationStatus: null,
};
export default withStyles(styles)(HeaderV2);
